const FAN = 'fan';
const SUPER_FAN = 'super_fan';
const PREMIUM = 'premium';
const PREMIUM_PLUS = 'premium_plus';

export { FAN, SUPER_FAN, PREMIUM, PREMIUM_PLUS };
